/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Parking place for the vehicle.     * `StreetOrOther`             - german: Straße, Sonstige   * `Garage`                    - german: Garage   * `Parkhouse`                 - german: Sammel-/Tiefgarage, Parkhaus   * `PrivateOrCompanyProperty`  - german: Privat-/Betriebsgrundstück
 */
export const ParkingPlace = {
  Street: 'Street',
  Garage: 'Garage',
  Parkhouse: 'Parkhouse',
  PrivateOrCompanyProperty: 'PrivateOrCompanyProperty',
} as const;
export type ParkingPlace = (typeof ParkingPlace)[keyof typeof ParkingPlace];
